export const CONTACT_DETAIL_FETCH_REQUESTED = 'CONTACT_DETAIL_FETCH_REQUESTED'
export const CONTACT_DETAIL_FETCH_SUCCESS = 'CONTACT_DETAIL_FETCH_SUCCESS'
export const CONTACTS_ROW_DATA_FETCH_SUCCESS = 'CONTACTS_ROW_DATA_FETCH_SUCCESS'
export const CONTACTS_ROW_DATA_FETCH_REQUESTED = 'CONTACTS_ROW_DATA_FETCH_REQUESTED'
export const CONTACTS_DETAIL_UPDATE_SUCCESS = 'CONTACTS_DETAIL_UPDATE_SUCCESS'
export const CONTACTS_DETAIL_UPDATE_REQUESTED = 'CONTACTS_DETAIL_UPDATE_REQUESTED'
export const CONTACTS_EMPLOYEES_FETCH_REQUESTED = 'CONTACTS_EMPLOYEES_FETCH_REQUESTED'
export const CONTACTS_EMPLOYEES_FETCH_SUCCESS = 'CONTACTS_EMPLOYEES_FETCH_SUCCESS'
export const CONTACT_CREATE_REQUESTED = 'CONTACT_CREATE_REQUESTED'
export const CONTACT_CREATE_SUCCESS = 'CONTACT_CREATE_SUCCESS'
